// These are external urls that may be transformed by the WAF-mapping
// entering the routes may redirect to a different host (e.g. the IAM host)
export enum AuthenticationUrl {
    EBANKING = '/portal/ebanking', // maps to => /next aka eBanking landing page
    EBANKING_MAIL = '/portal/ebanking-mail', // maps to => /next/#/mail aka mail page
    EBANKING_DOCUMENTS = '/portal/ebanking-documents', // maps to => /next/#/documents/summary aka documents page
    EBANKING_PRODUCTS = '/portal/ebanking-payment-slip', // maps to => /next/#/products aka product creation page
    LOGIN = '/portal/login',
    LOGOUT = '/portal/logout?logout=true',
    PASSWORD_CHANGE = '/authen/password-change?Location=/portal/',
    SELF_REGISTRATION = '/portal/self-registration',
    SESSION_TIMEOUT = '/portal/anonymous-forward?session-timeout=true',
}
